import { Pipe, PipeTransform } from '@angular/core';
import { BookingOption, bookingOptionCancellationPolicyLabel } from '@greco/booking-events';

@Pipe({ name: 'cancellationPolicyLabel' })
export class CancellationPolicyLabelPipe implements PipeTransform {
  transform(bookingOption: BookingOption) {
    return bookingOptionCancellationPolicyLabel(bookingOption);
  }
}
